import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import NaturalPersonList from "./NaturalPersonList";
import NaturalPersonCreate from "./NaturalPersonCreate";
import NaturalPersonEdit from "./NaturalPersonEdit";
import NaturalPersonDetailPage from "./NaturalPersonDetailPage";
import { NaturalPersonReportChange } from "./NaturalPersonReportChange";
import { RouteGuard } from "../../guards/RouteGuard";
import { RoleEnum } from "../../types/RoleEnum";
function NaturalPersons() {
    var path = useRouteMatch().path;
    var cleanPath = path.replace("/*", "");
    return (React.createElement(Switch, null,
        React.createElement(Route, { exact: true, path: cleanPath, render: function () { return (React.createElement(RouteGuard, { allowedRoles: [
                    RoleEnum.AGENCY_WORKER,
                    RoleEnum.PUBLISHER_GUARANTOR,
                    RoleEnum.PUBLISHER_ADMIN,
                    RoleEnum.DISTRIBUTOR,
                ] },
                React.createElement(NaturalPersonList, null))); } }),
        React.createElement(Route, { path: "".concat(cleanPath, "/create"), render: function () { return (React.createElement(RouteGuard, { allowedRoles: [
                    RoleEnum.PUBLISHER_GUARANTOR,
                    RoleEnum.PUBLISHER_ADMIN,
                ] },
                React.createElement(NaturalPersonCreate, null))); } }),
        React.createElement(Route, { path: "".concat(cleanPath, "/edit/:id"), render: function () { return (React.createElement(RouteGuard, { allowedRoles: [
                    RoleEnum.PUBLISHER_GUARANTOR,
                    RoleEnum.PUBLISHER_ADMIN,
                ] },
                React.createElement(NaturalPersonEdit, null))); } }),
        React.createElement(Route, { path: "".concat(cleanPath, "/report-change/:id"), render: function () { return (React.createElement(RouteGuard, { allowedRoles: [
                    RoleEnum.PUBLISHER_GUARANTOR,
                    RoleEnum.PUBLISHER_ADMIN,
                ] },
                React.createElement(NaturalPersonReportChange, null))); } }),
        React.createElement(Route, { path: "".concat(cleanPath, "/detail/:id"), render: function () { return (React.createElement(RouteGuard, { allowedRoles: [
                    RoleEnum.AGENCY_WORKER,
                    RoleEnum.PUBLISHER_GUARANTOR,
                    RoleEnum.PUBLISHER_ADMIN,
                    RoleEnum.DISTRIBUTOR,
                ] },
                React.createElement(NaturalPersonDetailPage, null))); } })));
}
export default NaturalPersons;
